module.exports = __webpack_public_path__ + "img/sesion_activa.6952394d.png";